'use client';
import Link from 'next/link';
import NextImage from '@/features/Image';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { ZepidTubeSkeleton } from './ZepidTubeSkeleton';

// Define the shape of the data for type safety
type ZepidTubeData = {
  title: string;
  description: string;
  banner_web: string;
  btn_name: string;
  route: string;
};

// The component is now ASYNC and takes NO PROPS
const ZepidTube = () => {
  // ✅ DATA IS FETCHED HERE, INSIDE THE COMPONENT
  const { data: homeThings, isLoading } = useFetcherCSR(
    `/api/v2/home-things?for=desktop`
  );
  // const homeThings = await fetcher('/api/v2/home-things?for=desktop');
  const data = homeThings?.homepage_settings?.kireitube as
    | ZepidTubeData
    | undefined;

  // If there's no data, don't render the section
  if (!data || !homeThings?.homepage_settings?.features?.kireitube) {
    return null;
  }

  if (isLoading) return <ZepidTubeSkeleton />;

  // Helper function to safely parse a URL path
  const getPathname = (
    route: string | undefined,
    defaultPath: string
  ): string => {
    if (!route) return defaultPath;
    try {
      return new URL(route).pathname;
    } catch (e) {
      if (route.startsWith('/')) return route;
    }
    return defaultPath;
  };

  const linkPath = getPathname(data.route, '/zepid-tube');

  return (
    <section className="newsletter padding-top padding-bottom section-bg">
      <div className="container">
        <div className="row zepidtube">
          <div className="col-md-6 content">
            <h2>{data?.title}</h2>
            <p dangerouslySetInnerHTML={{ __html: data?.description }}></p>
            {/* {data?.description && parse(data?.description)} */}
            <Link href={`${linkPath}`} className="trk-btn trk-btn--primary">
              {data?.btn_name}
            </Link>
          </div>
          <div className="col-md-6">
            <div className="zepidtube-image mx-auto mt-4">
              <NextImage
                width={289}
                height={401}
                src={data?.banner_web}
                alt="Discover with Zepid Tube"
                className="newsletter-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZepidTube;
